/** Normalize BPMN XML so server vs modeler formatting does not trigger redundant importXML (SCRUM-304). */
export function normalizeBpmnXmlForCompare(xml: string): string {
	return xml.replace(/\r\n/g, '\n').replace(/>\s+</g, '><').replace(/\s+/g, ' ').trim()
}

export function shouldSkipStaleBpmnReimport(options: {
	normalizedIncoming: string
	normalizedEditorXml: string
	isSaveInFlight: boolean
	saveStatus: 'idle' | 'dirty' | 'saving' | 'saved' | 'error'
	hasUnsavedChanges: boolean
}): boolean {
	return (
		options.isSaveInFlight ||
		options.saveStatus === 'saving' ||
		options.saveStatus === 'dirty' ||
		options.hasUnsavedChanges
	)
}
